import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateTaxonomicGroupDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateTaxonomicGroup(
  taxonomicGroupId: string,
  data: UpdateTaxonomicGroupDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.taxonomicGroups.update(taxonomicGroupId),
    data,
  );
  return response.data;
}
